import numeral from "numeral";

// Países que usan punto para miles, coma para decimales
const DOT_THOUSANDS = [
  "Argentina", "Chile", "Colombia", "Uruguay", "Paraguay",
  "Ecuador", "Bolivia", "Venezuela", "España", "Brasil", "Brazil",
  "Perú", "Peru",
];

// Países donde los centavos no tienen uso práctico
const NO_DECIMALS = ["Argentina", "Chile", "Paraguay"];

// Registrar locales
numeral.register("locale", "es-latam", {
  delimiters: { thousands: ".", decimal: "," },
  abbreviations: { thousand: "k", million: "m", billion: "b", trillion: "t" },
  currency: { symbol: "$" },
});

numeral.register("locale", "en-latam", {
  delimiters: { thousands: ",", decimal: "." },
  abbreviations: { thousand: "k", million: "m", billion: "b", trillion: "t" },
  currency: { symbol: "$" },
});

let _symbol = "$";
let _useDecimals = true;

export const setCurrencySymbol = (symbol) => {
  if (symbol) _symbol = symbol;
};

export const getCurrencySymbol = () => _symbol;

export const setCurrencyLocale = (country) => {
  if (!country) return;
  const useDotThousands = DOT_THOUSANDS.some(
    (c) => c.toLowerCase() === country.toLowerCase()
  );
  numeral.locale(useDotThousands ? "es-latam" : "en-latam");
  _useDecimals = !NO_DECIMALS.some(
    (c) => c.toLowerCase() === country.toLowerCase()
  );
};

export const formatCurrency = (value, decimals = false) => {
  const showDecimals = decimals && _useDecimals;
  const fmt = showDecimals ? "0,0.00" : "0,0";
  return `${_symbol} ${numeral(value).format(fmt)}`;
};
